export const Messages = {
  generic: 'Lo sentimos, ocurrió un error inesperado',
  orderAlreadyCompleted: 'Esta orden ya fue procesada. Tu lista se actualizará automáticamente.',
  timeout: 'Ocurrió un error en el servidor, el tiempo de espera se ha agotado',
  connectionRefused: 'Parece que tienes problemas de conexión. Revisa tu internet e intenta de nuevo.',
  redirectionError: 'Ocurrió un error inesperado',
  endSession: 'Sesión cerrada con éxito',
  unauthorized: 'Sesion expirada',
  generalHttpMessage: 'Proceso realizado con éxito',
  addNewProduct:
    'El producto seleccionado ya se encuentra en el carrito, ¿deseas agregarlo con la nueva combinación de envase y etiqueta?',
  notFound: '',
  productAddedToCart: 'Producto agregado al carrito: ',
  packageAddedToCart: 'Paquete agregado al carrito: ',
  deleteProductCard: '¿Deseas eliminar el producto del carrito?',
  deleteProductCardSaved: '¿Deseas eliminar el producto del carrito guardado?',
  deletePackageCard: '¿Deseas eliminar el paquete del carrito?',
  deleteProductListOrder: '¿Deseas eliminar el producto de la lista?',
  numbersMoreThatZero: 'Solo se aceptan números mayores a 0 (cero)',
  infoUpdated: 'La información se actualizó con éxito',
  typeImageError: 'Solo se aceptan archivos de tipo PNG, JPG y JPEG',
  sizeImageError:
    'La imagen selecionada excede el tamaño permitido(4Mb), intente con otra',
  confirmReplaceImagesLogo:
    'La imagen anterior de logo será reemplazda por la imagen selccionada',
  confirmReplaceImagesSignature:
    'Ya cuentas con una firma digital creada, ¿deseas reemplazarla?',
  licenseValidationFailed:
    'El nombre del doctor no coincide con la cédula profesional principal',
  licenseNotFount: 'No se encontró información de la cédula profesional',
  licenseServiceUnavailable: 'No fue posible verificar la cédula profesional en este momento. Ya estamos al tanto de este inconveniente y estamos trabajando para resolverlo. Por favor, intenta nuevamente más tarde o contacta a tu asesor.',
  successSaveLicense: 'La cédula profesional ha sido verificada correctamente y los datos han sido guardados exitosamente.',
  licenseNotFountInSap:
    'Tu usuario no cuenta con una cédula registrada en nuestro sistema, favor de contactar a tu asesor',
  repeatedLicense: 'No se puede registrar una cédula profesional repetida',
  unsuccessfulValidation: 'Error de validación de cédula',
  successfulValidation: 'El médico responsable se agregó con éxito',
  nameLicenseNoMatched: 'El nombre del doctor no coincide con la cédula profesional',
  licenseExist: 'Ya existe un registro con la cédula ingresada',
  repeatedAliases: 'El Alias ingresado ya existe',
  addressAdded: 'La dirección de entrega se agregó con éxito',
  addressUpdated: 'La dirección de entrega se actualizó con éxito',
  addressRecipedUpdated: 'Actualización exitosa',
  addressRecipedAdd: 'La dirección de receta se agregó con éxito',
  infoAddTaxData: 'Los datos fiscales se agregaron con éxito',
  infoEditTaxData: 'Los datos fiscales se actualizaron con éxito',
  deliveryAddressDelete: '¿Deseas eliminar la dirección de entrega?',
  smsSendCorrectly:
    'Se ha enviado un sms con el código de seguridad al número de teléfono registrado en el sistema',
  missingInfoOnProfile:
    'Te hacen falta datos para generar tu receta, complétalos',
  taxDataAddressDelete: '¿Deseas eliminar los datos fiscales?',
  zipCodeNotFound: 'No se encontró el código postal',
  noSendSmsValidation:
    'Ocurrió un error al ma dar en SMS de validación. Favor de intentar más tarde',
  deleteFromFavorites: '¿Deseas eliminar el producto de tus favoritos?',
  deleteAddressFromRecipeSettings: '¿Deseas eliminar la dirección de receta?',
  authorizeRecipe: 'Se autorizó correctamente la receta',
  notPrescription: 'El pedido no cuenta con una receta asociada',
  aliasExists: 'El Alias ingresado ya existe',
  paymentCardEdited: 'El método de pago se actualizó con éxito.',
  paymentCardSaved: 'El método de pago se agregó con éxito.',
  invalidUser:
    'No es posible autorizar recetas digitales de otros usuarios médicos.',
  clinicInfoRepeated: 'No se puede registrar un nombre de clínica repetido.',
  clinicInfoWasDeleted: 'La información de la clínica fue eliminada con éxito',
  confirmationToDeleteClinicInfo: '¿Deseas eliminar la clínica o consultorio?',
  clinicInfoWasAdded: 'La información de la clínica fue agregada con éxito',
  clinicInfoWasUpdate: 'La información de la clínica fue actualizada con éxito',
  updateProfilePhoto: 'La foto de perfil se actualizó con éxito',
  invoiceError: 'No se encontró información de la factura ingresada.',
  saveSuccess: 'Se guardo con éxito la información',
  succesSaveUtilities: 'Los nuevos precios se guardarón con éxito',
  birthDayIsNull:
    'Falta ingresar la fecha de cumpleaños en información personal',
  noSaveInformation: 'Tienes información sin guardar. ¿Deseas continuar?',
  infoProfileAdviserSaveSuccess: 'La información fue guardada con éxito',
  phoneError:
    'No se puede guardar el teléfono, validar si tiene un formato correct o una dirección de receta prederminada',
  academicInfoNoAvailable: 'No hay información académica disponible',
  authorizeOrder: 'Se autorizó correctamente la orden',
  alreadyExistFilter: 'El filtro que intentas agregar ya existe',
  cardDeleted: 'La tarjeta fue eliminada con éxito',
  recipeDirecctionDeleted: 'La dirección de receta fue eliminada con éxito',
  deliveryAddressDeleted: 'La dirección de entrega fue eliminada con éxito',
  taxAddressDeleted: 'Los datos fiscales fueron eliminados con éxito',
  confirmDeletePendingOrder: '¿Estás seguro de eliminar orden?',
  deletedPedingOrder: 'La orden se ha eliminado correctamente.',
  invalidContainer: 'Favor de seleccionar un envase',
  prescriptionSavedSuccessfully: 'Las recetas se actualizaron con éxito',
  invalidInvoice:
    'Realiza el pago de las facturas anteriores para poder pagar una más reciente',
  downloadCatalogFailed: 'Catálogo no disponible',
  noPrescriptionQty:
    'No hay recetas disponibles para agregar nombre de paciente',
  pdfUploadFailed:
    'Hubo un error al momento de cargar el pdf, intentarlo de nuevo',
  pdfEmpty: 'El pedido no cuenta con receta digital',
  serviceQualifierSuccess:
    'La información se guardó correctamente, muchas gracias por participar en la calificación de nuestro servicio',
  confirmExitApp:
    'Usted está apunto de salir de la plataforma y accederá a una página externa. ¿Desea continuar?',
  resendMailSuccess: 'El correo se reenvió correctamente',
  deleteInvoiceTransaction: '¿Deseas que la transacción sea eliminada?',
  validateInvoicePdfFail: 'El pedido no cuenta con una factura generada',
  validateInvoiceXmlFail: 'El pedido no cuenta con un XML disponible',
  noRecipe: 'La orden no cuenta con receta digital',
  licenseNotFound: 'La cédula no es válida, inténta  con otra.',
  invalidDirectionTitle: 'Dirección de entrega incompleta',
  invalidDirectionTextDoctor: 'Da clic en editar y completa la dirección',
  invalidDirectionText:
    'no cuenta con médico responsable, favor de contactarlo para poder continuar con el pedido.',
  invalidCfdiTitle: 'Datos fiscales incompletos',
  invalidCfdiText:
    ' cuenta con los datos fiscales incompletos, favor de contactarlo para poder continuar con el pedido.',
  invalidCfdiTextDoctor: 'Da clic en editar y completa los datos',
  invalidGenderSelection:
    'Es necesario seleccionar un género para generar la receta',
  invalidRecipeTitle: 'Receta incompleta',
  invalidRecipeText:
    'Verifica la información de tus recetas dando click en Personaliza tus recetas',
  zipCodeNoValid: 'Favor de ingresar un CP',
  paymentMethodValidation: 'El monto máximo permitido es de $',
  numberOfPaymentCards: 'Lo sentimos, solo se permite agregar hasta 5 tarjetas',
  oxxoValidation:
    'El monto máximo permitido es de $10,000 MXN, intenta con otro método de pago',
  selectMethod: 'Favor de seleccionar un método de pago para poder continuar',
  pendingPayments:
    'Realice el pago de sus facturas vencidas para poder continuar',
  insufficientCredit:
    'Su compra excede el monto de su línea de crédito permitida',
  pendingInvoices:
    'Realice el pago de sus facturas vencidas para poder continuar',
  invalidRecipeSettings:
    'Por lo menos una de tus recetas necesita revisión. Favor de comprobar el género, piezas o diagnóstico, respectivamente.',
  invalidPatientsWithDiagnosis:
    'Por lo menos una de tus recetas necesita revisión. Debes tener un solo diagnóstico para cada paciente.',
  invalidDiagnosis: 'Revisa que todos tus diagnósticos se encuentren asignados',
  invalidContainerSelection:
    'El envase seleccionado ya se encuentra en el carrito, favor de elegir un envase diferente',
  oneProductSavedInSavedCart: 'se ha guardado correctamente',
  allShoppingCartSaved: 'Todo el carrito se ha guardado correctamente',
  shoppingCart: 'carrito',
  shoppingCartSaved: 'carrito guardado',
  addNewProductToSavedCart:
    'El producto seleccionado ya se encuentra en el carrito guardado, ¿deseas agregarlo con la nueva combinación de envase y etiqueta?',
  utilityProductsAdded:
    'Los productos se agregaron correctamente a tu carrito de compras',
  allProductInCarAgain:
    'El carrito guardado ha regresado al carrito correctamente',
  oneProductSavedICart: 'ha regresado al carrito correctamente',
  invalidPageNumber: 'Página inválida.',
  invalidQuotationProductsQuantity:
    'Has rebasado el máximo de productos a cotizar, favor de disminuir el numero de productos',
  incompleteRecipe:
    'Dirección de receta incompleta, agregar campos obligatorios',
  titlePendingOrderRemainingPieces:
    'Al descartar la sugerencia no se actualizará la orden',
  subTitlePendingOrderRemainingPieces:
    '*Si todos los productos de la orden no tienen piezas disponibles, se eliminará la orden',
  titleConfirmOrderRemainingPieces:
    'Al descartar la sugerencia tendrá que ajustar el pedido manualmente',
  repeatAliasBusinessName: 'La razón social ingresada ya existe',
  invalidFavorBalanceShoppingCar:
    'Por un cambio en los costos o dirección de entrega el Saldo a Favor no podrá ser utilizado',
  invalidFavorBalancePendingOrders:
    'Por un cambio en los costos el Saldo a Favor no podrá ser utilizado',
  infoBBVAPaymentTooltip:
    'Con la plataforma Multipagos de BBVA podrás realizar el pago con tarjetas de débito o crédito de cualquier banco, cheque en línea (transferir de BBVA a BBVA), Transferencias SPEI o Practicaja.',
  paymentFailure: 'Error al generar el pago, favor de intentarlo de nuevo',
  emptySheetsXML: 'No se encontraron Hojas en el archivo',
  invalidFormat: 'Formato incorrecto, favor de seleccionar un Excel',
  invalidMinAmount:
    'El monto mínimo de compra debe ser mayor o igual al descuento del código',
  emailSend: 'Se ha enviado el correo electrónico con éxito',
  cartChanges:
    'Se han detectado cambios en su carrito, será direccionado al carrito de compras para su revisión',
  creditNotesChanges:
    'El saldo a favor utlizado ha sufrido cambios, ¿Deseas continuar sin el saldo a favor?',
  invalidBusinessNameTitle: 'Sociedad no válida',
  invalidBusinessNameSubtitle: 'Edita la sociedad de la Razón Social',
  shoppingCartMinPieces: 'Debe ajustar la cantidad necesaria para proceder con su compra.',
  editAndRepurchaseMaxPieces: 'Debe ajustar la cantidad necesaria o eliminar el producto para proceder con su compra.',
  confirmOrderCar: 'Será redireccionado al carrito de compras para ajustar la cantidad necesaria para proceder con su compra.',
  confirmOrderRebuy: 'Será redireccionado a Editar y volver a comprar para ajustar la cantidad necesaria para proceder con su compra.',
  changePaymethod: 'Los productos serán eliminados de su compra',
  shoppingCartMinMax: {
    min: 'Será redireccionado al carrito de compras para actualizar el mínimo de piezas por producto',
    max: 'Será direccionado al carrito de compras para actualizar el máximo de piezas por producto',
    minMax: 'Será redireccionado al carrito de compras para ajustar la cantidad necesaria para proceder con su compra'
  },
  rebuyOrderMinMax: {
    min: 'Será redireccionado a Editar y volver a comprar para actualizar el mínimo de piezas por producto',
    max: 'Será direccionado a Editar y volver a comprar para actualizar el máximo de piezas por producto',
    minMax: 'Será redireccionado a Editar y volver a comprar para ajustar la cantidad necesaria para proceder con su compra'
  },
  successPay: {
    checkEmailMessges:
      'Consulta en tu email el correo de confirmación, si el mensaje no se encuentra en tu bandeja de entrada revisa tu carpeta de spam o correo no deseado.',
    adviseTenDaysMessages: 'Una vez procesado tu pago el pedido lo debes recibir en un máximo de 10 días naturales.'
  },
  addressPromotionWarning: 'El código promocional ingresado no es válido para la dirección seleccionada',
  codeIsNoLongerValid: 'El código promocional ya no es válido. Vuelve a ingresarlo',
  invoiceInformationIcon:
    `Factura completa: una sola factura al final, cuando todos los productos estén listos.
  Factura parcial: varias facturas, una por cada entrega, según vayan estando disponibles los productos.`
};
export const TitleButtons = {
  accept: 'Aceptar',
  cancel: 'Cancelar',
  back: 'Volver'
};
export const TitlesMaxMinPieces = {
  maxPiecesDefault: 'Se excede la <strong>compra máxima de piezas</strong> para los siguientes productos dentro del periodo establecido.',
  minPiecesDefault: 'Se requiere <strong>compra mínima de piezas</strong> para los siguientes productos.',
};
export const messageHTML = {
  confirmDeleteOrder: `<div>
  <div class="d-flex flex-column align-items-center justify-content-center">
    <img src="./assets/icons/warning_dialog.svg" alt="warning">
    <h2 class=" color-black mb-0">¡Atención!</h2>
  </div>
      <h2 class="">¿Está seguro que desea eliminar la orden?</h2>
      <p class="text-size-3 color-black mb-0">Una vez realizado el pago se recomienda <span class="font-omicron-bold">no eliminarlo,</span> póngase en contacto con su asesor para más detalle.</p>
  </div>`,
};
export const licenseValidationHTML = {
  succesful: `<div>
  <div class="d-flex flex-column align-items-center justify-content-center">
    <img src="./assets/icons/success.svg" alt="success">
  </div>
      <h2 class="">Validación exitosa</h2>
      <p class="text-size-3 color-black mb-0">La cédula profesional ha sido verificada correctamente y los datos del médico han sido guardados exitosamente.</p>
  </div>`,
};
